// Direct copy of Wellendorff's approach
window.addEventListener("message", (e) => {
  if (e.data.type === "windowHeight") {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${e.data.innerHeight}px`);
  }
});

// Initial height report
window.parent.postMessage({
  type: "capolavoroMicrositeFrameHeight",
  height: document.body.scrollHeight,
}, "*");

// Regular height reports, exactly like Wellendorff
setInterval(() => {
  window.parent.postMessage({
    type: "capolavoroMicrositeFrameHeight",
    height: document.body.scrollHeight,
  }, "*");
}, 1000);